/**
 * @author NikolaV
 */
import { Ajax } from '@shared/Ajax';
import { ILayerWrapperOptions, LayerWrapper } from '../LayerWrapper';
import { GeojsonFeatureCollection } from '@shared/geojson/types';

import { GeoJSON } from 'ol/format';

const GEOJSON_FORMAT = new GeoJSON();

export class ModelsLayer extends LayerWrapper<IOutlineLayer> {
    featureType: FeatureType = 'model';

    constructor(opts: ILayerWrapperOptions<IOutlineLayer>,
        private readonly pointLayer: LayerWrapper<IOutlinePoint>,
        private readonly tekPointLayer: LayerWrapper<IOutlinePoint>) {

        //opts.layerBuilderFn = () => new WebGLLayer({})  // works but no hit detection for now
        super(opts);

        this.layer.set('id', this.featureType);
    }


    fetchFile(modelId: number): JQueryPromise<any> {
        this.removeFeaturesBySource({ modelId });
        return Ajax({
            url: `api/1/file/${modelId}/outlines.json`
        }).then((resp: IOutlinesAjaxResponse) => {
            if(!resp.outlines) {
                console.warn('outlines.json returned empty file, no outlines');
                return;
            }
            
            resp.outlines.points.forEach(p => p.sourceModelId = modelId);

            return $.Deferred().resolve(resp);
        }, resp =>
            // eslint-disable-next-line no-restricted-globals
            $.Deferred().reject(resp, status, 'ajax error'));
    }

    fetchAndDrawFile(modelId: number): JQueryPromise<any> {
        this.removeFeaturesBySource({ modelId });

        return Ajax({
            url: `api/1/file/${modelId}/outlines.json`
        }).then((resp: IOutlinesAjaxResponse) => {
            if(!resp.outlines) {
                console.warn('outlines.json returned empty file, no outlines');
                return;
            }

            resp.outlines.points.forEach(p => p.sourceModelId = modelId);

            const points = this.pointLayer.drawAll(resp.outlines.points);
            const layers = this.drawAll(resp.outlines.layers);

            const success = points && layers;
            return success ? $.Deferred().resolve(resp) : $.Deferred().reject(resp);
        }, resp =>
            // eslint-disable-next-line no-restricted-globals
            $.Deferred().reject(resp, status, 'ajax error'));
    }


    drawGeoJSON(id: number, name: string, geojson: GeojsonFeatureCollection) {

        const features = GEOJSON_FORMAT.readFeatures(geojson, {
            featureProjection: "EPSG:3857",
        });

        for (const feature of features) {
            const props = feature.getProperties();
            delete props.geometry;

            const polySource: FeatureSource = {
                modelId: id,
                modelName: name,
            };

            feature.set('type', 'model');
            feature.set('source', polySource);
            feature.set('mouseInteraction', this.mouseInteraction);
            feature.set('data', { name: name, props: props, color: "117,191,255" });
        }

        this.allFeatures.push(...features);
        this.layerSource.addFeatures(features);
        return { features };
    }

    removeFeaturesBySource(source: FeatureSource) {
        super.removeFeaturesBySource(source);
    }
}
